import { TableConfig } from '../../../util/table-config.utils';
import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { PaginationComponent } from '@components/custom-table/table-footer/pagination/pagination.component';

@Component({
    selector: 'app-table-footer',
    templateUrl: 'table-footer.component.html',
    styleUrls: ['table-footer.component.scss']
})
export class TableFooterComponent {
    @ViewChild(PaginationComponent, {static: false}) paginator: PaginationComponent;

    @Input() selectableRows = false;
    @Input() config = new TableConfig();
    @Input() hasPagination = true;

    @Output() pageChange = new EventEmitter<any>();

    onPageChange() {
        this.pageChange.emit(this.config);
    }
}
